import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://wearspray.com";
export const SITE_NAME = "WearSpray";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og/wearspray-social-preview-v2.jpg`;

/**
 * Per-route SEO tags: title, meta description, canonical link, Open Graph +
 * Twitter Card tags, and optional JSON-LD structured data. Rendered via
 * react-helmet-async so tags land in the real document <head> both in the
 * browser and — critically — in the static HTML produced by the react-snap
 * build-time prerender (see package.json "reactSnap" config).
 */
export function SEO({ title, description, path = "/", image = DEFAULT_OG_IMAGE, jsonLd, noindex = false }) {
  const canonical = `${SITE_URL}${path === "/" ? "" : path}`;
  const extraJsonLd = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  // Organization schema ships on every route per the SEO work order (Part 3.2.4).
  const jsonLdList = [ORGANIZATION_JSON_LD, ...extraJsonLd];

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, follow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLdList.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}

export const ORGANIZATION_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "WearSpray",
  url: SITE_URL,
  logo: `${SITE_URL}/wearspray-logo-2026.png`,
  description:
    "WearSpray is a patented, refillable wearable dispensing platform that puts sunscreen, lotion or repellent one press away on the wrist.",
  sameAs: [],
};
